module.exports = __webpack_public_path__ + "static/media/(000152).205d6d2d.jpg";